/* eslint-disable react/display-name */
import React, { HTMLProps, useCallback, useState } from "react";
import classNames from "classnames";
import currency from "currency.js";
import { InputProps } from "./textarea.props";
import { defaultNumericOpts } from "../../../utils/string";

export const TextArea: React.FunctionComponent<
  InputProps & HTMLProps<HTMLTextAreaElement>
> = React.forwardRef(
  (
    {
      value,
      onChange,
      placeholder,
      invalid,
      inputSize,
      className,
      inputClassName,
      style,
      error,
      material,
      label,
      hint,
      enableCounter,
      maxChar,
      ...rest
    },
    ref
  ) => {
    const [focus, setFocus] = useState<boolean>(false);
    const [limitReached, setLimitReached] = useState<boolean>(false);

    const handleChange = useCallback(
      (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        const isLimitReached = maxChar && event.target.value?.length >= maxChar;
        setLimitReached(isLimitReached);
        if (isLimitReached) {
          event.target.value = event.target.value.substring(0, maxChar);
        }
        onChange(event);
      },
      [maxChar, onChange]
    );

    return (
      <div className={`flex flex-col ${className}`}>
        {!!label && (
          <p className="font-bold text-gray text-label-sm">{label}</p>
        )}
        <div className="w-full flex flex-row">
          <textarea
            ref={ref}
            value={value}
            placeholder={placeholder}
            onChange={handleChange}
            onFocus={() => setFocus(true)}
            onBlur={() => setFocus(false)}
            style={{ paddingRight: invalid ? 56 : 12, ...style }}
            className={classNames(
              "form-control text-body2 text-gray",
              inputClassName,
              { "is-invalid": !!invalid },
              { "py-6": inputSize === "bigger" },
              { "border border-danger": error },
              { "material-input": !focus && material },
              { "highlight-input-border": focus && material }
            )}
            {...rest}
          />
        </div>
        {(!!hint || enableCounter) && (
          <div className="flex justify-between">
            {!!hint && (
              <small className="flex text-black text-opacity-50">{hint}</small>
            )}
            {enableCounter && maxChar && (
              <div
                className={`flex justify-end text-right w-full ${
                  limitReached ? "text-orange" : "text-black text-opacity-50"
                }`}
              >
                {value?.length
                  ? currency(value.length, defaultNumericOpts).format()
                  : 0}
                /{maxChar ? currency(maxChar, defaultNumericOpts).format() : 0}
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
);
